import type { RentalResultsFilterValue } from './rental_results_filters.js';

// Ordinal, não localeCompare: os códigos das locadoras são chave do corpo, não texto exibido.
const byCodeUnit = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0);

/** O corpo `filters` do `/rental/search`: os eixos que o servidor corta. Os
 *  valores de `transmission`/`airConditioning` são os do `RentalSearchFilter`
 *  do upstream; eixo ausente = sem corte. */
export type RentalServerFilters = {
  readonly categoryCode?: string;
  readonly companyIds?: string[];
  readonly onlyPolicyWithIn?: true;
  readonly transmission?: 'AUTOMATIC';
  readonly airConditioning?: 'WITH_AIR_CONDITIONING';
};

/**
 * Os filtros da tela que o servidor sabe cortar (#5121), para a busca trazer
 * já na 1ª página o que a pessoa pediu em vez de a rolagem varrer páginas
 * atrás de uma locadora que ainda não veio. É um SUBCONJUNTO do corte: o
 * `matchesRentalResultsFilters` continua valendo no cliente sobre o que chega.
 *
 * Categoria só vai com UMA marcada: o upstream filtra um `categoryCode`, e
 * duas categorias são "uma OU outra" — essas ficam no corte do cliente. Faixa
 * de diária e nome da agência também. As locadoras saem ordenadas para que a
 * mesma seleção dê o mesmo corpo (é a chave que recomeça a paginação).
 */
export function rentalServerFiltersOf(filters: RentalResultsFilterValue): RentalServerFilters {
  const [onlyCategory, ...otherCategories] = filters.categoryIds;
  return {
    ...(onlyCategory !== undefined && otherCategories.length === 0
      ? { categoryCode: onlyCategory }
      : {}),
    ...(filters.companyIds.length > 0
      ? { companyIds: [...filters.companyIds].sort(byCodeUnit) }
      : {}),
    ...(filters.policyOnly ? { onlyPolicyWithIn: true } : {}),
    ...(filters.accessories.includes('automatic') ? { transmission: 'AUTOMATIC' } : {}),
    ...(filters.accessories.includes('air-conditioning')
      ? { airConditioning: 'WITH_AIR_CONDITIONING' }
      : {}),
  };
}
